"use strict";

var _taggedTemplateLiteral = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
Object.defineProperty(exports, "__esModule", {
  value: true
});
const codegen_1 = require("ajv/dist/compile/codegen");
const _util_1 = require("./_util");
const error = {
  message: _ref => {
    let {
      params: {
        schemaProp
      }
    } = _ref;
    return schemaProp ? (0, codegen_1.str)(_templateObject || (_templateObject = _taggedTemplateLiteral(["should match case \"", "\" schema"])), schemaProp) : (0, codegen_1.str)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["should match default case schema"])));
  },
  params: _ref2 => {
    let {
      params: {
        schemaProp
      }
    } = _ref2;
    return schemaProp ? (0, codegen_1._)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["{failingCase: ", "}"])), schemaProp) : (0, codegen_1._)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["{failingDefault: true}"])));
  }
};
function getDef(opts) {
  const metaSchema = (0, _util_1.metaSchemaRef)(opts);
  return [{
    keyword: "select",
    schemaType: ["string", "number", "boolean", "null"],
    $data: true,
    error,
    dependencies: ["selectCases"],
    code(cxt) {
      const {
        gen,
        schemaCode,
        parentSchema
      } = cxt;
      cxt.block$data(codegen_1.nil, () => {
        const valid = gen.let("valid", true);
        const schValid = gen.name("_valid");
        const value = gen.const("value", (0, codegen_1._)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["", " === null ? \"null\" : ", ""])), schemaCode, schemaCode));
        gen.if(false); // optimizer should remove it from generated code
        for (const schemaProp in parentSchema.selectCases) {
          cxt.setParams({
            schemaProp
          });
          gen.elseIf((0, codegen_1._)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\"\" + ", " == ", ""])), value, schemaProp)); // intentional ==, to match numbers and booleans
          const schCxt = cxt.subschema({
            keyword: "selectCases",
            schemaProp
          }, schValid);
          cxt.mergeEvaluated(schCxt, codegen_1.Name);
          gen.assign(valid, schValid);
        }
        gen.else();
        if (parentSchema.selectDefault !== undefined) {
          cxt.setParams({
            schemaProp: undefined
          });
          const schCxt = cxt.subschema({
            keyword: "selectDefault"
          }, schValid);
          cxt.mergeEvaluated(schCxt, codegen_1.Name);
          gen.assign(valid, schValid);
        }
        gen.endIf();
        cxt.pass(valid);
      });
    }
  }, {
    keyword: "selectCases",
    dependencies: ["select"],
    metaSchema: {
      type: "object",
      additionalProperties: metaSchema
    }
  }, {
    keyword: "selectDefault",
    dependencies: ["select", "selectCases"],
    metaSchema
  }];
}
exports.default = getDef;
module.exports = getDef;